import * as React from 'react';
import { observer, inject } from 'mobx-react';
import ExternalConnections from '../components/ExternalConnections';
import FlexContentContainer from '../../common/components/FlexContentContainer';
import { RulesStores } from '../stores';
import { STORE_RULES_EXTERNAL_CONNECTIONS } from '../constants';

type Props = RulesStores;

export const ExternalConnectionsListPage: React.FC<Props> = () => {
    const content = <ExternalConnections />;

    return <FlexContentContainer content={content} />;
};

export default inject(STORE_RULES_EXTERNAL_CONNECTIONS)(observer(ExternalConnectionsListPage));
